import GeneralTableCell from "./GeneralTableCell";
import TextLevelTableCell from "./TextLevelTableCell";
export { GeneralTableCell, TextLevelTableCell };
